<script setup lang="ts">
import TypographyComponent from './TypographyComponent.vue'

defineProps<{ count: number }>()
</script>

<template>
  <TypographyComponent v-if="count" variant="label-medium" color="var(--inverted)" class="count-badge">
    {{ count }}
  </TypographyComponent>
</template>

<style lang="scss" scoped>
.count-badge {
  border-radius: 24px;
  background: var(--primary);
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;
}
</style>
